// extracted by mini-css-extract-plugin
export default {"customStyle":"AppLoader_customStyle__dB7sZ"};